import type { RefObject } from 'react';
import type { HeadingRef } from '../../../atoms/heading/Heading.data';
import type { TextRef } from '../../../atoms/text/Text.data';
import { findTransitionController } from '../../../../util/core-transition-component';

interface DescriptionListItemRefs {
  elementRef?: RefObject<HTMLElement | null>;
  lineRef?: RefObject<HTMLSpanElement | null>;
  numberRef?: RefObject<HeadingRef | null>;
  descriptionRef?: RefObject<TextRef | null>;
  titleRef?: RefObject<HeadingRef | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { lineRef, numberRef, descriptionRef, titleRef }: DescriptionListItemRefs,
): void {
  const number = findTransitionController(numberRef);
  const title = findTransitionController(titleRef);
  const description = findTransitionController(descriptionRef);

  if (lineRef?.current) {
    timeline.fromTo(
      lineRef.current,
      { scaleX: 0, transformOrigin: 'left center' },
      { duration: 0.5, ease: 'Quad.easeInOut', scaleX: 1 },
    );
  }

  if (number) {
    timeline.add(number.getTimeline('in') as gsap.core.Timeline, 0);
  }

  if (title) {
    timeline.add(title.getTimeline('in') as gsap.core.Timeline, 0);
  }

  if (description) {
    timeline.add(description.getTimeline('in') as gsap.core.Timeline, 0.1);
  }
}
